<template>
  <div>
    <div class="row">
      <div class="col-4">
        <span @click="switchComponent('WorkDetailsModal')">
          جزئیات
        </span>
      </div>
    </div>
    <!--<div class="modal detailModal fade" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="workDetailModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            ...
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>-->
    <b-modal
      ref="detail-modal"
      id="detailModal"
      size="xl"
      :title="'جزئیات سفارش '+ orderDetail.productName"
      ok-title="بستن"
      ok-only
      @hide="resetFlowchartFlag"
    >
      <div class="works-table" v-if="isFlowchart === false">
        <div class="row">
          <div class="col-lg-12 p-0">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">کد</th>
                <th scope="col">تکمیل شده</th>
                <th scope="col">جزئیات</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in workDetail">
                <td>{{index + 1}}</td>
                <td>{{item.code}}</td>
                <td v-if="item.completed === true"><span
                  class="badge badge-success">{{badgeText(item.completed)}}</span>
                </td>
                <td v-else><span class="badge badge-warning">{{badgeText(item.completed)}}</span></td>
                <td>
                  <button class="btn btn-secondary" @click="loadWorkFlowchartComponent(true, item)">
                    <i class="icon-eye-outline"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="flowchart" v-else>
        <div class="back-to-table" @click="loadWorkFlowchartComponent(false)">
          <i class="fa fa-reply"></i>
        </div>
        <div class="row">
          <div class="col-2 mt-3">
            <div class="col mt-1">
              <span class="badge badge-warning" style="background-color: #FF8F00; font-size: 10px;">درصف انتظار</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-success" style="background-color: #9E9D24; color: black; font-size: 10px">درحال انجام</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-success" style="background-color: #2E7D32; font-size: 10px">تکمیل شده</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-info text-white"
                    style="background-color: #0277BD; font-size: 10px;">تایید شده</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-primary" style="background-color: #deddff; font-size: 10px">غیرفعال</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-danger" style="background-color: #c62828; font-size: 10px">مشکل</span>
            </div>
          </div>
          <div class="col-10 d-flex align-items-center">
            <work-flowchart ref="flowchart" :works="innerWorkDetails"></work-flowchart>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
    import "../assets/js/jquery.min";
    import {mapState, mapMutations, mapActions} from "vuex";
    import EventBus from "../bus.js";
    import {bus} from '../main';
    import VsSelect from "../_framework/VsSelect";
    import VsTable from "../_framework/VsTable.vue";
    import BaseService from "../_framework/api/BaseService.js";
    import WorkChart from "../components/WorkChart.vue";
    import WorkStatus from "../components/WorkStatus.vue";
    import WorkFlowchart from "./WorkFlowchart.vue";


    export default {
        name: "work-details-modal",
        props: {
            orderDetail: Object,
            currentComp: {
                type: String,
            }
        },
        components: {
            VsSelect,
            VsTable,
            WorkChart,
            WorkStatus,
            WorkFlowchart
        },
        data() {
            return {
                isFlowchart: false,
                successBadge: null,
                innerWorkDetails: {},
                workDetail: [],
                isCompleted: [],
                productName: null,
            }
        },
        mounted() {
        },
        methods: {
            switchComponent(comp) {
                this.$refs['detail-modal'].show()
                this.getOrderDetail();
                bus.$emit('switchComp', comp);
            },
            getOrderDetail() {
                // console.log(this.orderId)
                new BaseService('CustomerOrders', `/GetOrderDetailWorks/${this.orderDetail.id}`).getList().then((response) => {
                    // console.log(response.data)
                    this.innerWorkDetails = response.data;
                    this.workDetail = this.innerWorkDetails.works;
                }).catch((error) => {
                    console.log(error)
                })
            },
            badgeText(value) {
                // console.log(value)
                if (value === false) {
                    return "درحال انجام"
                } else if (value === true) {
                    return "تکمیل شده"
                }
            },
            loadWorkFlowchartComponent(show, work) {
                this.isFlowchart = show;
                // this.$refs.flowchart.workDetail= "asd";
                setTimeout(() => {
                    if (this.$refs.flowchart !== undefined) {
                        this.$refs.flowchart.getFlowchartDetail(work);
                    }
                }, 10)
            },
            resetFlowchartFlag() {
                setTimeout(() => {
                    this.isFlowchart = false
                }, 500)
            }
        },
        computed: {
            ...mapState(["selectedRows", "currentService", "vsTableFeed"])
        },
        watch: {
            vsTableFeed(val) {
                //this.refreshMaterialTable();
            },
        }
    };
</script>

<style scoped>
  .back-to-table {
    display: flex;
    justify-content: flex-end;
    color: #9370db;
  }

  .back-to-table i {
    font-size: 1.5rem;
  }
</style>
